import React, { useEffect, useMemo, useState } from "react";
import { Table, Button, Space, Tag, Flex } from "antd";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";
import CustomInput from "../../../../components/input/CustomInput";
import ConfirmModal from "../../../../components/modal/ConfirmModal";

const LotteryNumbersPage = ({ trigger, activeKey }) => {
  const { id: lotteryId } = useParams();

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    phoneNumber: "",
    num: "",
  });
  const [bulkMode, setBulkMode] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showDisableConfirm, setShowDisableConfirm] = useState(false);
  const toast = useToast();

  const cancelBulk = () => {
    setBulkMode(false);
    setSelectedRowKeys([]);
    setShowDisableConfirm(false);
  };

  const rowSelection = useMemo(() => {
    if (!bulkMode) return null;

    return {
      selectedRowKeys,
      preserveSelectedRowKeys: true, // ✅ page солигдоход хадгална
      onChange: (keys) => setSelectedRowKeys(keys),

      getCheckboxProps: (record) => ({
        disabled: record.active === false,
      }),

      // ✅ "All select" дээр merge хийх custom selection
      selections: [Table.SELECTION_INVERT, Table.SELECTION_NONE],

      onSelectAll: (selected, selectedRows, changeRows) => {
        // changeRows = энэ page дээр өөрчлөгдсөн мөрүүд
        const pageKeys = changeRows.map((r) => r.id);

        setSelectedRowKeys((prev) => {
          const set = new Set(prev);
          if (selected) {
            // энэ page-ийнхийг нэм
            pageKeys.forEach((k) => set.add(k));
          } else {
            // энэ page-ийнхийг хас
            pageKeys.forEach((k) => set.delete(k));
          }
          return Array.from(set);
        });
      },
    };
  }, [bulkMode, selectedRowKeys]);

  const disableSelected = async () => {
    if (!selectedRowKeys.length) return;

    try {
      setLoading(true);
      const res = await api.lottery_numbers_bulk_active(lotteryId, {
        ids: selectedRowKeys,
        active: false,
      });

      if (res.status === 200) {
        toast("Амжилттай идэвхгүй болголоо", "success");
        cancelBulk();
        fetchData();
      } else {
        toast(res.data?.message || "Алдаа гарлаа", "error");
      }
    } catch (e) {
      toast(e?.response?.data?.message || "Серверийн алдаа", "error");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Төлөв",
      dataIndex: "active",
      key: "active",
      width: 200,
      render: (val) => (
        <Tag color={val ? "blue" : "red"}>{val ? "Идэвхтэй" : "Идэвхгүй"}</Tag>
      ),
    },
    {
      title: "Дугаар",
      dataIndex: "number",
      key: "number",
      width: 100,
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      width: 100,
    },
    {
      title: "Зарагдсан эсэх",
      dataIndex: "is_sold",
      key: "is_sold",
      width: 120,
      render: (val) => (val ? "Тийм" : "Үгүй"),
    },
    {
      title: "Утас",
      key: "phone",
      dataIndex: "LotteryTicket",
      width: 120,
      render: (ticket) => ticket?.phone_number || "-",
    },
    {
      title: "Үүсгэсэн огноо",
      dataIndex: "created_at",
      key: "created_at",
      width: 200,
      render: (val) => dayjs(val).format("YYYY-MM-DD HH:mm"),
    },
  ];

  const handleTableChange = (pag) => {
    setPagination((prev) => ({
      ...prev,
      current: pag.current,
      pageSize: pag.pageSize,
    }));
  };

  const fetchData = async () => {
    if (!lotteryId) return;
    setLoading(true);
    const params = {
      page: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (filters.phoneNumber) {
      params.phoneNumber = filters.phoneNumber;
    }

    if (filters.num) {
      params.num = filters.num;
    }

    const res = await api.get_lottery_numbers(lotteryId, params);

    // console.log("number List  -->", res);

    const { pagination: pagi } = res.data;

    if (res.data.status === 200) {
      setData(res.data.data);
      setPagination((prev) => ({
        ...prev,
        current: pagi.page,
        pageSize: pagi.pageSize,
        total: pagi.total,
      }));
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (activeKey === "1" && lotteryId) {
      fetchData();
    }
  }, [
    lotteryId,
    pagination.current,
    pagination.pageSize,
    filters,
    trigger,
    activeKey,
  ]);

  return (
    <div>
      <Flex justify="space-between">
        <Space style={{ marginBottom: 16 }}>
          <CustomInput
            placeholder="Утасны дугаар хайх"
            value={filters.phoneNumber}
            onChange={(e) => {
              const val = e.target.value;
              setFilters((prev) => ({ ...prev, phoneNumber: val }));
              setPagination((prev) => ({ ...prev, current: 1 }));
            }}
            // onSearch={(val) => {
            //   setPagination((prev) => ({ ...prev, current: 1 }));
            //   fetchData();
            // }}
            style={{ width: 200 }}
            allowClear
          />
          <CustomInput
            placeholder="Сугалааны дугаар хайх"
            value={filters.num}
            onChange={(e) => {
              const val = e.target.value;
              setFilters((prev) => ({ ...prev, num: val }));
              setPagination((prev) => ({ ...prev, current: 1 }));
            }}
            allowClear
            style={{ width: 200 }}
          />
          <Button
            size="large"
            onClick={() => {
              setFilters({ num: "", phoneNumber: "" });
              setPagination((prev) => ({ ...prev, current: 1 }));
            }}
          >
            Цэвэрлэх
          </Button>
        </Space>

        {!bulkMode ? (
          <Button
            danger
            type="link"
            size="large"
            onClick={() => setBulkMode(true)}
          >
            Дугаар идэвхгүй болгох
          </Button>
        ) : (
          <div>
            <Button
              size="large"
              style={{ marginRight: 10 }}
              onClick={cancelBulk}
            >
              Болих
            </Button>

            <Button
              danger
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={() => setShowDisableConfirm(true)}
            >
              Идэвхгүй болгох ({selectedRowKeys.length})
            </Button>
          </div>
        )}
      </Flex>

      <Table
        columns={columns}
        rowKey="id"
        dataSource={data}
        loading={loading}
        rowSelection={rowSelection || undefined}
        rowClassName={(record) => (!record.active ? "row-inactive" : "")}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50"],
          showTotal: (total) => `Нийт ${total} үр дүн`,
        }}
        onChange={handleTableChange}
      />

      <ConfirmModal
        showModal={showDisableConfirm}
        variant="warning"
        title="Идэвхгүй болгох уу?"
        description={`Анхааруулга: Сонгосон ${selectedRowKeys.length} дугаарыг идэвхгүй болгосны дараа буцаах боломжгүй. Та үргэлжлүүлэхдээ итгэлтэй байна уу?`}
        setShowModal={setShowDisableConfirm}
        cancelHandler={() => setShowDisableConfirm(false)}
        submitHandler={async () => {
          setShowDisableConfirm(false);
          await disableSelected();
        }}
      />
    </div>
  );
};

export default LotteryNumbersPage;
